import s from "styled-components";
import { CheckboxLabel } from "_c/Checkbox";
import { StyledRadio } from "_c/Radio";

const Fieldset = s.fieldset`
  border-radius: 4px;
  border: ${({ theme }) => theme.border.light};
  ${CheckboxLabel} {
    margin-bottom: 5px;
  }
  ${StyledRadio} {
    margin-bottom: 5px;
  }
  margin-bottom: 15px;
`;
export default Fieldset;
